import axiosIns from '@/libs/axios'
import uploadWithProgress from '@/store/helpers/upload'

const ROOT_URL = '/Admin/data/service_files'
export default {
  namespaced: true,
  state: {
    loading: false,
    secretLoading: false,
    uploading: false,
    uploadProgress: {
      loaded: 0,
      total: 0,
    },
    dataList: [],
    dataSecretList: [],
    dataCounts: 0,
    dataSecretCounts: 0,
    dataItem: {
      id: null,
      id_licenses: null,
      unique_hash: null,
      title: null,
      notes: null,
      file_name: null,
      file_type: null,
      file_size: null,
      is_secret: false,
      id_document_groups: null,
      id_services: null,
      id_users: null,
      CurrentVersion: null,
      versionOptions: {
        version_type: 'major',
        major: 1,
        minor: 0,
        patch: 0,
        status: 'alpha',
        prev_version_id: null,
        brief_description: null,
        release_notes: null,
      },
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
    filterParams: {
      id_services: null,
      id_document_groups: null,
      is_secret: null,
      keywords: null,
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    secretLoading(state) {
      return state.secretLoading
    },
    uploading(state) {
      return state.uploading
    },
    uploadProgress(state) {
      return state.uploadProgress
    },
    dataList(state) {
      return state.dataList
    },
    secretDataList(state) {
      return state.dataSecretList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataSecretCounts(state) {
      return state.dataSecretCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
    filterParams(state) {
      return state.filterParams
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_LOADING_SECRET(state, data) {
      state.secretLoading = data
    },
    SET_UPLOADING(state, data) {
      state.uploading = data
    },
    SET_UPLOAD_PROGRESS(state, data) {
      state.uploadProgress = data
    },
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_SECRET_LIST(state, data) {
      state.dataSecretList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SECRET_COUNTS(state, data) {
      state.dataSecretCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        id_licenses: null,
        unique_hash: null,
        title: null,
        notes: null,
        file_name: null,
        file_type: null,
        file_size: null,
        is_secret: false,
        id_document_groups: null,
        id_services: null,
        id_users: null,
        CurrentVersion: null,
        versionOptions: {
          version_type: 'major',
          major: 1,
          minor: 0,
          patch: 0,
          status: 'alpha',
          is_alpha: false,
          prev_version_id: null,
          brief_description: null,
          release_notes: null,
        },
      }
    },
  },
  actions: {
    getDataList({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_DATA_ITEM')
      commit('SET_DATA_LIST', [])
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    getDataSecretList({ commit }, params) {
      commit('SET_LOADING_SECRET', true)
      commit('SET_DATA_SECRET_LIST', [])
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_SECRET_LIST', response.data.data)
          commit('SET_DATA_SECRET_COUNTS', response.data.count)
          commit('SET_LOADING_SECRET', false)
        })
        .catch(error => console.error(error))
    },
    async getDataItem({ commit }, id) {
      if (Number(id)) {
        commit('SET_LOADING', true)
        commit('RESET_DATA_ITEM')
        const data = {
          where: {
            'service_files.id': id,
          },
          array: false,
        }
        return axiosIns
          .post(ROOT_URL, data)
          .then(response => {
            commit('SET_DATA_ITEM', response.data.data)
            commit('SET_LOADING', false)
            return response.data.data
          })
          .catch(error => console.error(error))
      }
      return false
    },
    saveData({ commit }, postData) {
      const formData = new FormData()
      // post data nın bütün elemanlarını döndür ve formData ya appendle
      Object.entries(postData).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          // Eğer value bir obje ise JSON string'e çevir
          if (typeof value === 'object' && !(value instanceof File)) {
            formData.append(key, JSON.stringify(value))
          } else {
            formData.append(key, value)
          }
        }
      })
      return uploadWithProgress(commit, `${ROOT_URL}/saveData`, formData)
    },
    removeData({ commit }, id) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch(error => console.error(error))
    },
    resetDataItem({ commit }) {
      commit('RESET_DATA_ITEM')
    },
  },
}
